import CustomElement from "./CustomElement";
import gsap from "gsap"
export default class VideoPlayer extends CustomElement {

	constructor() {
		super();
    this.videoEl = this.querySelector("video")
    this.playing = this.videoEl.autoplay
    this.btn = this.querySelector("button")
    this.playLabel = this.btn.querySelector(".play-btn")
    this.pauseLabel = this.btn.querySelector(".pause-btn")
    this.btn.addEventListener("click", this.handleClick.bind(this))
	}

  handleClick(e) {
    e.preventDefault();

    if(this.playing) {
      this.videoEl.pause()
      this.playing = false

      //show play btn
      gsap.set(this.playLabel, {visibility: "visible"})
      gsap.set(this.pauseLabel, {visibility: "hidden"})

    } else {
      this.videoEl.play()
      this.playing = true

      //show pause btn
      gsap.set(this.pauseLabel, {visibility: "visible"})
      gsap.set(this.playLabel, {visibility: "hidden"})
    }

  }
}
